import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import GoogleAuth from './../GoogleAuth';
import CreateMeet from "../CreateMeet"
import { gapi } from 'gapi-script';
import { useState, useRef } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import AWS from 'aws-sdk';
AWS.config.update({    
    accessKeyId: "AKIAWZB5KF6EBGT3RIHI",
    secretAccessKey: "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",
    region: "us-west-2"
});    

const CLIENT_ID ="523035007236-7f6m5foajf6ecrk25klplsl0e3t8abom.apps.googleusercontent.com";
const API_KEY = "AIzaSyBQTjwInbt7LjpL2T1X7NjfPGUBHDbSGQs";
const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];
const SCOPES = "https://www.googleapis.com/auth/calendar.readonly";
const AddSCOPES = "https://www.googleapis.com/auth/calendar.events";

const localizer = momentLocalizer(moment);


const createDraftMeetEvent = async (eventName, eventDescription, start, end, showmeetlink, setMeetLink, setGenerateloading) => {
    const event = {
        summary: eventName,
        description: eventDescription,
        start: {
            dateTime: start,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        end: {
            dateTime: end,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        conferenceData: {
            createRequest: {
                requestId: 'sample123',
                conferenceSolutionKey: {
                    type: 'hangoutsMeet',
                },
            },
        },
    };

    const request = gapi.client.calendar.events.insert({
        calendarId: 'primary',
        resource: event,
        conferenceDataVersion: 1,
    });

    request.execute(event => {
        console.log(event.hangoutLink, "Meet Link");
        setMeetLink(event.hangoutLink);
        // showmeetlink(event.hangoutLink);

        // Save eventId for later use
        localStorage.setItem('eventId', event.id);
        setGenerateloading(false)
    });
};

const finalizeMeetEvent = async (email, eventName, eventDescription, start, end, showmeetlink, setMeetLink, setGenerateloading1, useremail, setShowsendmessage) => {
    const eventId = localStorage.getItem('eventId');

    const event = {
        summary: eventName,
        description: eventDescription,
        start: {
            dateTime: start,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        end: {
            dateTime: end,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        attendees: [
            { email: email },
            { email: useremail },
        ],
        reminders: {
            useDefault: false,
            overrides: [
                { method: 'email', minutes: 24 * 60 },
                { method: 'popup', minutes: 10 },
            ],
        },
    };

    const request = gapi.client.calendar.events.patch({
        calendarId: 'primary',
        eventId: eventId,
        resource: event,
        conferenceDataVersion: 1,
        sendUpdates: 'all',
    });

    request.execute(event => {
        console.log(event.hangoutLink, "Finalized Meet Link");
        showmeetlink(event.hangoutLink);
        // setMeetLink(event.hangoutLink);
        setGenerateloading1(false)

    });
};
const Adminmeeting = () => {
    const location = useLocation();
    const [params, setParams] = useState({});
    const [start, setStart] = useState("");
    const [start1, setStart1] = useState("");
    const [start2, setStart2] = useState("");
    const [end, setEnd] = useState("");
    const [Status, setStatus] = React.useState('');
    const [userdata, setUserdata] = useState("");
    const [continue1, setContinue1] = useState(false);
    const [continue2, setContinue2] = useState(false);
    const [eventName, setEventName] = useState("");
    const [eventDescription, setEventDescription] = useState("");
    const [personalfirstname, setPersonalfirstname] = useState("");
    const [personallastname, setPersonallastname] = useState("");
    const [personalemail, setPersonalemail] = useState("");
    const [personalphone, setPersonalphone] = useState("");
    const [locations, setLoaction] = useState('');
    const [showgmeetlink, setShowgmeetlink] = React.useState('');
    const [showemailoption, setShowemailoption] = React.useState(false);
    const [showsendmessage, setShowsendmessage] = React.useState(false)
    const meetLinkInputRef = useRef(null);
    const [email, setEmail] = React.useState('avinash20802bala@gmail.com');
    const [meetLink, setMeetLink] = React.useState('');
    const [generateloading, setGenerateloading] = React.useState(false);
    const [generateloading1, setGenerateloading1] = React.useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [highlight, setHighlight] = React.useState(false);
    const [sentemail, setSentemail] = React.useState(false);
    const [selectdate, setSelectedate] = useState('');
    const [datesata, setDatedata] = useState([]);
    const [addclass, setAddclass] = React.useState(null);
    const inputRef = useRef(null);
    const [errors, setErrors] = useState({});
    const [events, setEvents] = useState([]);
    const [isSignedIn, setIsSignedIn] = useState(false);
    const [userProfile, setUserProfile] = useState(null);


    const validateForm = () => {
        let formErrors = {};
        if (!eventName) formErrors.eventName = 'Meeting title is required';
        if (!eventDescription) formErrors.eventDescription = 'Meeting description is required';
        if (!start) formErrors.start = 'Start time is required';
        // if (!email) formErrors.email = 'Email is required';
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };
    // function revertDateTime(isoString) {
    //     const date = new Date(isoString);
    //     return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}.000Z`;
    // }
    // function formatDateTime(dateTime) {
    //     const date = new Date(dateTime);
    //     return date.toISOString();
    // }
    function revertDateTime(isoString) {
        const date = new Date(isoString);
        // Convert to UTC string to avoid local timezone conversion issues
        return `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')}T${date.getUTCHours().toString().padStart(2, '0')}:${date.getUTCMinutes().toString().padStart(2, '0')}:${date.getUTCSeconds().toString().padStart(2, '0')}.000Z`;
    }

    function formatDateTime(dateTime) {
        const date = new Date(dateTime);

        // Get the time zone offset in minutes and adjust the date accordingly
        const offset = date.getTimezoneOffset(); // Time zone offset in minutes

        // Adjust date by the time zone offset to ensure it is UTC
        date.setMinutes(date.getMinutes() - offset);

        // Convert the adjusted date to ISO string (UTC format)
        return date.toISOString();
    }

    function showmeetlink(link) {
        console.log(link, "Meet link");
        setShowgmeetlink(link);
    }


    function showemailoptionnow(data = "") {
        console.log(data, "show data link");
        setShowemailoption(data);
        // fetchEvents();
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const decodedParams = {
            first: decodeURIComponent(searchParams.get('first') || ''),
            eventname: decodeURIComponent(searchParams.get('eventname') || ''),
            eventdesp: decodeURIComponent(searchParams.get('eventdesp') || ''),
            useremail: decodeURIComponent(searchParams.get('email') || ''),
            activetab: searchParams.get('virtual') ? decodeURIComponent(searchParams.get('virtual')) : decodeURIComponent(searchParams.get('facetoface') || ''),
        };
        setParams(decodedParams);
        setLoaction(decodeURIComponent(searchParams.get('location') || ''));
        if (decodedParams.first) {
            try {
                const parsedData = JSON.parse(decodedParams.first);
                console.log(parsedData, "Parsed Data");
                setDatedata(parsedData);
            } catch (error) {
                console.error("Error parsing start data:", error);
            }
        } else {
            console.warn("No valid JSON data found in 'first'");
        }
    }, [location]);

    useEffect(() => {
        const initClient = () => {
            gapi.client
                .init({
                    apiKey: API_KEY,
                    clientId: CLIENT_ID,
                    discoveryDocs: DISCOVERY_DOCS,
                    scope: SCOPES,
                })
                .then(() => {

                    const authInstance = gapi.auth2.getAuthInstance();

                    const signedIn = authInstance.isSignedIn.get();
                    console.log("Initial signed in state:", signedIn);

                    authInstance.isSignedIn.listen(() => {
                        const signedIn = authInstance.isSignedIn.get();
                        if (signedIn) {

                        }
                    });

                });

            gapi.load('client:auth2', initClient);
        }

    }, []);


    useEffect(() => {
        function initClient() {
            gapi.client
                .init({
                    apiKey: API_KEY,
                    clientId: CLIENT_ID,
                    discoveryDocs: DISCOVERY_DOCS,
                    scope: AddSCOPES,
                }).then(() => {
                    const authInstance = gapi.auth2.getAuthInstance();

                    const signedIn = authInstance.isSignedIn.get();
                    setIsSignedIn(signedIn);

                    console.log("Initial signed in state:", signedIn);

                    if (signedIn) {
                        const profile = authInstance.currentUser.get().getBasicProfile();
                        // console.log(showemailoptionnoww, "showemailoptionnowwshowemailoptionnowwshowemailoptionnoww")
                        setUserProfile({
                            name: profile.getName(),
                            email: profile.getEmail(),
                            imageUrl: profile.getImageUrl(),
                        });
                        console.log("User profile:", profile);
                    }
                })
        };
        gapi.load('client:auth2', initClient);
        console.log("initClient");
        setTimeout(() => {
            fetchEvents()
        }, 3000);
    }, []);


    const fetchEvents = () => {
        gapi.client.calendar.events
            .list({
                calendarId: 'primary',
                timeMin: new Date().toISOString(),
                showDeleted: false,
                singleEvents: true,
                maxResults: 10,
                orderBy: 'startTime',
            })
            .then((response) => {
                const events = response.result.items.map((event) => ({
                    title: event.summary,
                    start: new Date(event.start.dateTime || event.start.date),
                    end: new Date(event.end.dateTime || event.end.date),
                }));
                setEvents(events);
                console.log(events);
            })
            .catch((err) => console.error("Error fetching events", err));
    };




    function continuethis(e) {
        e.preventDefault();
        setContinue1(true)

    }
    function copyToClipboard() {
        if (meetLinkInputRef.current) {
            meetLinkInputRef.current.select();
            document.execCommand('copy');
            alert('Meet link copied to clipboard');
        }
    }
    function setUserdatanow(data = "") {
        console.log(data, "User data");
        setUserdata(data);
    }

    const selectfirst =  (first) => {
        setSelectedate('first')
        setStart1(first)
        setEventName(params.eventname)
        setEventDescription(params.eventdesp)
        setAddclass(prevValue => prevValue === first ? null : first);
        
        { console.log(first) }

    }
    const AddEventincalender = async (eventName, eventDescription, start, end) => {
        const startDate = new Date(start).toISOString();  // Converts to ISO 8601 string
        const endDate = new Date(end).toISOString();
        const event = {
            summary: eventName, // Title of the event
            description: eventDescription, // Description of the event
            start: {
                dateTime: startDate, // Start time in ISO 8601 format
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // User's local time zone
            },
            end: {
                dateTime: endDate, // End time in ISO 8601 format
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // User's local time zone
            },
            reminders: {
                useDefault: false,
                overrides: [
                    { method: 'email', minutes: 24 * 60 }, // Reminder 1 day before
                    { method: 'popup', minutes: 10 }, // Reminder 10 minutes before
                ],
            },
            // Optional: Remove `conferenceData` if you don't want to include Google Meet links
        };

        console.log('Event Payload:', JSON.stringify(event, null, 2));

        try {
            const response = await gapi.client.calendar.events.insert({
                calendarId: 'primary', // Use 'primary' for the user's primary calendar
                resource: event,
            });

            console.log('Event created successfully:', response);
        } catch (error) {
            console.error('Error creating event:', error.result);
        }
    };

    const selectsecond = (second) => {
        setSelectedate('second')
        setEventName(params.eventname)
        setEventDescription(params.eventdesp)
        { console.log(second) }

    }
    const selectthird = (third, eventname, eventdesp) => {
        setSelectedate('third')
        setEventName(eventname)
        setEventDescription(eventdesp)
        { console.log(third) }

    }

    const selectotherdate = () => {
        setEventName(params.eventname)
        setEventDescription(params.eventdesp)

    }
    const showformatDate = (dateString) => {
        return dateString.replace('T', ' ');
    };


    const handleGenerateLink = (e) => {
        e.preventDefault();
        setGenerateloading(true);
        const formattedStart = start ? formatDateTime(start) : revertDateTime(start1);
        const formattedEnd = start ? formatDateTime(start) : revertDateTime(start1);
        console.log(formattedStart, "formattedStart");
        console.log(datesata, "formattedStart");

        createDraftMeetEvent(params.eventname, params.eventdesp, formattedStart, formattedEnd, showmeetlink, setMeetLink, setGenerateloading);
    };

    const handleSendInvite =async (e) => {
        e.preventDefault();
        setGenerateloading1(true);
        setShowsendmessage(true);
        const formattedStart = start ? formatDateTime(start) : revertDateTime(start1);
        const formattedEnd = start ? formatDateTime(start) : revertDateTime(start1);
        console.log(formattedStart, "formattedStart");
        console.log(formattedEnd, "formattedStart");
        setEventDescription(params.eventdesp)
        await finalizeMeetEvent(email, eventName, eventDescription, formattedStart, formattedEnd, showmeetlink, setMeetLink, setGenerateloading1, params.useremail, setShowsendmessage);
        await  AddEventincalender(params.eventname, params.eventdesp, start1, start1)
    };
    function formatDate(dateString) {
        const date = new Date(dateString);

        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${day} ${month} ${year} ${hours}:${minutes}`;
    }


    const sendEmail =async () => {
        setSentemail(true)
        var first = selectdate === "first" ? formatDate(start1) : "";
        var otherdate = start ? formatDate(start) : ""
        let sendto = "avinash20802bala@gmail.com";
        let senduser = params.useremail
        var subjectdata = "New Message for meeting"
        var messagedata = `
     <html lang="en">
     <head>
       <meta charset="UTF-8">
       <meta name="viewport" content="width=device-width, initial-scale=1.0">
     </head>
     <body style="font-family: Arial, sans-serif;margin: 0;padding: 0;background-color: #f4f4f4;">
       <div class="container" style="width: 100%;max-width: 600px;margin: 0 auto;background-color: #ffffff;border-radius: 8px; overflow: hidden; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);">
         <div class="header" style="background-color: #007bff;color: #ffffff;padding: 20px;text-align: center;">
           <h1>Face to Face Meeting Request Notification</h1>
         </div>
         <div class="body">
           <p style="font-size:16px;">I hope this email finds you well.</p>
           <p style="font-size:16px;">I wanted to inform you that we have received a request for a Face to Face Meeting Notification meeting. Below are the details of the request:</p>
           <p style="font-size:16px;">${`<b>Meeting Subject:</b>  ${params.eventname}`}</p>
           <p style="font-size:16px;">${`<b>Meeting Description:</b>  ${params.eventdesp}`}</p>
           <p style="margin-bottom:4px;font-size:16px; margin-top:0px;font-size:16px;">${first ? `<b>Meeting Date:</b> ${first}` : ""}</p>
           <p style="margin-bottom:4px;font-size:16px; margin-top:0px;font-size:16px;">${otherdate ? `<b>Meeting Date:</b> ${otherdate}` : ""}</p>    
           <p style="font-size:16px;"><b>Meeting Location:</b> ${locations}</p>
           <p style="font-size:16px;">If you have any questions, feel free to reply to this email.</p>
         </div>
       </div>
     </body>
     </html>
     `
        // Create an instance of the SES service
        const ses = new AWS.SES({ apiVersion: '2023-08-09' });
        const paramsss = {
            Destination: {
                ToAddresses: [sendto, senduser], // Replace with the recipient's email address
            },
            Message: {
                Body: {
                    Html: {
                        Data: messagedata // Email content
                    }
                },
                Subject: {
                    Data: subjectdata // Email subject
                }
            },
            Source: 'admin@brokeragentbase.com' // Replace with your verified sender email address
        };

        // Send the email
        ses.sendEmail(paramsss, (err, data) => {
            if (err) {
                console.error('Error sending email:', err);
            } else {
                console.log('Email sent successfully:', data);
                setSentemail(false);
                setShowsendmessage(true);
            }
        });
       await AddEventincalender(params.eventname, params.eventdesp, start1, start1)
    };
    const currentUrl = window.location.href;


    const handleCalInput = () => {
        setIsVisible(!isVisible);
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };



    return (

        <section className="schedule_meet">
            <div className="container">
                <div className="row">
                    <div className={`${showsendmessage ? "col-md-12" : "col-md-6"}`}>
                        <div className="form_v1_view">
                            <div className="wrapper">

                                {

                                    showsendmessage ?
                                        ""
                                        :
                                        <ul class="nav nav-tabs" role="tablist">
                                            {
                                                params.activetab === "virtual" ?
                                                    <li class="nav-item me-0 w-100">
                                                        <a href="#home1" class={`nav-link text-center ${params.activetab === "virtual" ? "active" : ""}`} data-bs-toggle="tab" role="tab">
                                                            Virtual
                                                        </a>
                                                    </li>
                                                    :
                                                    params.activetab === "facetoface" ?
                                                        <li class="nav-item me-0 w-100">
                                                            <a href="#profile1" class={`nav-link text-center ${params.activetab === "facetoface" ? "active" : ""}`} data-bs-toggle="tab" role="tab">
                                                                Face to Face
                                                            </a>
                                                        </li>
                                                        :
                                                        ""
                                            }
                                        </ul>
                                }

                                <div class="tab-content">

                                    <div class={`tab-pane fade ${params.activetab === "virtual" ? "active show" : ""}`} id="home1" role="tabpanel">
                                        <div class="needs-validation">
                                            {
                                                showsendmessage ?
                                                    <div className="float-left w-100 text-center d-flex align-items-start justify-content-between">
                                                        <div className="float-left w-100 text-center">
                                                            <h2>Successfully sent your <br />meeting request!</h2>
                                                            <p className="">Mamdoh has received your <br />meeting suggestion, expect an<br /> answer in your inbox.</p>
                                                            <p className="mb-1"><small>Email used: johndoe@gmail.com</small></p>
                                                            <p className="mb-0"><small><a href={currentUrl}>Change Info</a></small></p>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div class="row">
                                                        {/* <div class="col-md-12 mb-0">
                                                        <div className="form_group mb-3">
                                                            <label class="form-label" for="validationCustom01">Meeting Info</label>
                                                            <input class="form-control icon_v1" type="text" placeholder="Meeting Title" onChange={(e) => setEventName(e.target.value)} value={eventName ? eventName : params.eventname} readOnly />
                                                            <i class="h2 fi-chat-left opacity-80"></i>
                                                        </div>
                                                        <div className="form_group">
                                                            <textarea class="form-control" type="text" placeholder="Short Meeting Description" onChange={(e) => setEventDescription(e.target.value)} value={eventDescription ? eventDescription : params.eventdesp} readOnly />
                                                            <p className="mt-1"><small>Optional</small></p>
                                                        </div>
                                                    </div> */}
                                                        <div class="col-md-12 mb-0">
                                                            {/* {console.log(datesata, "datesata")} */}
                                                            <div className="form_group mb-3">
                                                                <label class="form-label" for="validationCustom01">Meeting Info</label>
                                                                <input class="form-control icon_v1" type="text" placeholder="Meeting Title" onChange={(e) => setEventName(e.target.value)} value={eventName ? eventName : params.eventname} readOnly />
                                                                {errors.eventName && <p className="text-danger">{errors.eventName}</p>}
                                                                <i class="h2 fi-chat-left opacity-80"></i>
                                                            </div>
                                                            <div className="form_group">
                                                                <textarea class="form-control" type="text" placeholder="Short Meeting Description" onChange={(e) => setEventDescription(e.target.value)} value={eventDescription ? eventDescription : params.eventdesp} readOnly />
                                                                {errors.eventDescription && <p className="text-danger">{errors.eventDescription}</p>}
                                                                <p className="mt-1"><small>Optional</small></p>
                                                            </div>
                                                        </div>
                                                        <div class="form_group w-100 ">
                                                            <label class="form-label" for="validationCustom02">Time & Date</label>
                                                            {
                                                                isVisible ?
                                                                    ""
                                                                    :
                                                                    <div className="float-left w-100 additional_time_slot col-md-12">
                                                                        <i class="h2 fi-calendar opacity-80"></i>

                                                                        <div className="float-left w-100 ps-5">
                                                                            {
                                                                                datesata ? datesata.map((data) => {
                                                                                    return (
                                                                                        <p onClick={() => selectfirst(data.value, params.eventname, params.eventdesp)} style={{ cursor: 'pointer' }}>
                                                                                            <span className={`selectgiven_time ${addclass === data.value ? "active" : ""}`}>{showformatDate(data.value ? data.value : "")}</span>
                                                                                        </p>
                                                                                    )
                                                                                })
                                                                                    :
                                                                                    ""
                                                                            }
                                                                        </div>
                                                                    </div>

                                                            }
                                                            {
                                                                isVisible ?
                                                                    <input
                                                                        ref={inputRef}
                                                                        className="form-control"
                                                                        type="datetime-local"
                                                                        id="inline-form-input"
                                                                        placeholder="Suggest a Time & Date"
                                                                        name="startDate"
                                                                        onChange={(e) => setStart(e.target.value)}
                                                                        onClick={() => selectotherdate()}
                                                                        value={start}
                                                                        style={{
                                                                            border: "1px solid #00000026",
                                                                        }}
                                                                        data-datepicker-options='{"altInput": true, "altFormat": "F j, Y", "dateFormat": "Y-m-d"}'
                                                                    />
                                                                    :
                                                                    ""
                                                            }

                                                            {errors.start && <p className="text-danger">{errors.start}</p>}
                                                            <p className="mt-1 text-primary" onClick={() => handleCalInput()} style={{ cursor: 'pointer' }}><small>Suggest additional times</small></p>
                                                        </div>

                                                        {
                                                            continue1 ?
                                                                <>
                                                                    <GoogleAuth showemailoptionnow={showemailoptionnow} setUserdatanow={setUserdatanow} />
                                                                    {
                                                                        showgmeetlink && showgmeetlink != "" ?
                                                                            <div class="col-md-12 mb-3">
                                                                                <div className="form_group">
                                                                                    <label class="form-label" for="validationCustomUsername">Meeting</label>
                                                                                    <input className="form-control icon_v1" type="text" placeholder="Google Meet" value={showgmeetlink} ref={meetLinkInputRef} readOnly />
                                                                                    <i className="h2 fa fa-clone opacity-80" onClick={copyToClipboard}></i>
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            <>
                                                                                {
                                                                                    showemailoption && showemailoption === true ?
                                                                                        <>
                                                                                            {
                                                                                                meetLink ?
                                                                                                    <></>
                                                                                                    :
                                                                                                    <>
                                                                                                        <form onSubmit={handleGenerateLink}>
                                                                                                            <button title="Generate the meeting Link by click on this button" className="btn btn-primary" type="submit" disabled={generateloading}>{generateloading ? "Plese Wait..." : "Continue"}</button>
                                                                                                        </form>
                                                                                                        <br />
                                                                                                    </>
                                                                                            }

                                                                                            {meetLink && (
                                                                                                <>
                                                                                                    {/* <p>Meet Link: <a href={meetLink}>{meetLink}</a></p> */}
                                                                                                    <div class="col-md-12 mb-3">
                                                                                                        <div className="form_group">
                                                                                                            <label class="form-label" for="validationCustomUsername">Meeting</label>
                                                                                                            <input className="form-control icon_v1" type="text" placeholder="Google Meet" value={meetLink} ref={meetLinkInputRef} readOnly />
                                                                                                            <i className="h2 fa fa-clone opacity-80" onClick={copyToClipboard}></i>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <form onSubmit={handleSendInvite}>
                                                                                                        <input class="d-none"
                                                                                                            type="email"
                                                                                                            placeholder="Enter email"
                                                                                                            value={email}
                                                                                                            onChange={(e) => setEmail(e.target.value)}
                                                                                                        />
                                                                                                        <br />
                                                                                                        <br />
                                                                                                        <button className="btn btn-primary" type="submit" disabled={generateloading1}>{generateloading1 ? "Plese Wait..." : "Accept & Add to Calendar"}</button>
                                                                                                    </form>
                                                                                                    {/* <button className="btn btn-primary" onClick={() => sendEmail()} type="submit" disabled={generateloading1}>{generateloading1 ? "Plese Wait..." : "Send"}</button> */}

                                                                                                </>
                                                                                            )}


                                                                                        </>

                                                                                        // <CreateMeet eventName={eventName} eventDescription={eventDescription} start={start} startdate={start1} startdates={start2} end={start} showmeetlink={showmeetlink} />
                                                                                        :
                                                                                        <></>
                                                                                }
                                                                            </>
                                                                    }
                                                                </>
                                                                :
                                                                <div>
                                                                    <button class="btn btn-primary" type="submit" onClick={(e) => continuethis(e)}>Continue</button>
                                                                </div>
                                                        }


                                                    </div>
                                            }

                                        </div>
                                    </div>


                                    <div class={`tab-pane fade ${params.activetab === "facetoface" ? "active show" : ""}`} id="profile1" role="tabpanel">
                                        <div class="needs-validation">
                                            {
                                                showsendmessage ?
                                                    <div className="float-left w-100 text-center d-flex align-items-start justify-content-between">
                                                        <div className="float-left w-100 text-center">
                                                            <h2>Successfully sent your <br />meeting request!</h2>
                                                            <p className="">Mamdoh has received your <br />meeting suggestion, expect an<br /> answer in your inbox.</p>
                                                            <p className="mb-1"><small>Email used: johndoe@gmail.com</small></p>
                                                            <p className="mb-0"><small><a href={currentUrl}>Change Info</a></small></p>
                                                        </div>
                                                    </div>
                                                    :
                                                    <>
                                                        <div class="row">
                                                            <div class="col-md-12 mb-0">
                                                                <div className="form_group mb-3">
                                                                    <label class="form-label" for="validationCustom01">Meeting Info</label>
                                                                    <input class="form-control icon_v1" type="text" placeholder="Meeting Title" onChange={(e) => setEventName(e.target.value)} value={eventName ? eventName : params.eventname} readOnly />
                                                                    {errors.eventName && <p className="text-danger">{errors.eventName}</p>}
                                                                    <i class="h2 fi-chat-left opacity-80"></i>
                                                                </div>
                                                                <div className="form_group">
                                                                    <textarea class="form-control" type="text" placeholder="Short Meeting Description" onChange={(e) => setEventDescription(e.target.value)} value={eventDescription ? eventDescription : params.eventdesp} readOnly />
                                                                    {errors.eventDescription && <p className="text-danger">{errors.eventDescription}</p>}
                                                                    <p className="mt-1"><small>Optional</small></p>
                                                                </div>
                                                            </div>
                                                            <div class="form_group w-100 ">
                                                                <label class="form-label" for="validationCustom02">Time & Date</label>
                                                                {
                                                                    isVisible ?
                                                                        ""
                                                                        :
                                                                        <div className="float-left w-100 additional_time_slot col-md-12">
                                                                            <i class="h2 fi-calendar opacity-80"></i>

                                                                            <div className="float-left w-100 ps-5 given_time_slot">
                                                                                {
                                                                                    datesata ? datesata.map((data) => {
                                                                                        return (
                                                                                            <p onClick={() => selectfirst(data.value, params.eventname, params.eventdesp)} style={{ cursor: 'pointer' }}>
                                                                                                <span className={`selectgiven_time ${addclass === data.value ? "active" : ""}`} >{showformatDate(data.value ? data.value : "")}</span>
                                                                                            </p>
                                                                                        )
                                                                                    })
                                                                                        :
                                                                                        ""
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                }
                                                                {
                                                                    isVisible ?
                                                                        <input
                                                                            ref={inputRef}
                                                                            className="form-control"
                                                                            type="datetime-local"
                                                                            id="inline-form-input"
                                                                            placeholder="Suggest a Time & Date"
                                                                            name="startDate"
                                                                            onChange={(e) => setStart(e.target.value)}
                                                                            onClick={() => selectotherdate()}
                                                                            value={start}
                                                                            style={{
                                                                                border: "1px solid #00000026",
                                                                            }}
                                                                            data-datepicker-options='{"altInput": true, "altFormat": "F j, Y", "dateFormat": "Y-m-d"}'
                                                                        />
                                                                        :
                                                                        ""
                                                                }

                                                                {errors.start && <p className="text-danger">{errors.start}</p>}
                                                                <p className="mt-1 text-primary" onClick={() => handleCalInput()} style={{ cursor: 'pointer' }}><small>Suggest additional times</small></p>
                                                            </div>
                                                            <div class="col-md-12 mb-3">
                                                                <div className="form_group">
                                                                    <label class="form-label" for="validationCustomUsername">Location</label>
                                                                    <input class="form-control icon_v1" type="text" placeholder="Enter Location" value={locations} onChange={(e) => setLoaction(e.target.value)} />
                                                                    <i class="h2 fi-map-pin opacity-80"></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            <div>
                                                                <button class="btn btn-primary" type="submit" onClick={(e) => sendEmail(e)}>{sentemail ? "Please Wait" : "Accept"}</button>
                                                            </div>
                                                        }

                                                    </>
                                            }
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    {
                        showsendmessage ?
                            ""
                            :
                            <div className="col-md-6">
                                <div className='d-flex align-items-center justify-content-start mt-4 ms-5'>
                                    <img src={userProfile?.imageUrl}  referrerPolicy="no-referrer"  style={{width:"70px",height:"70px", borderRadius: '100%' }} />
                                    <span className='ms-3'>
                                        <h6 className="mb-0">{userProfile?.name}</h6>
                                        <p className="mb-0">{userProfile?.email}</p>
                                    </span>
                                    
                                </div>
                                <Calendar
                                    localizer={localizer}
                                    events={events}
                                    startAccessor="start"
                                    endAccessor="end"
                                    style={{ height: 500, margin: '50px' }}
                                    selectable
                                    onSelectSlot={(slotInfo) => {
                                        const isAvailable = !events.some(
                                            (event) =>
                                                moment(slotInfo.start).isBetween(event.start, event.end, null, '[)')
                                        );
                                        alert(isAvailable ? "Date is available!" : "Date is already booked!");
                                    }}
                                />
                            </div>
                    }
                </div>
            </div>
        </section>





    );
};

export default Adminmeeting;
